import {RendererProps} from "../RendererProps";
import {ReactElement} from "react";
import {ensureNotObject, keyify} from "../common";

export function RenderDeleteUsers(props: RendererProps): ReactElement {
    const ids = props.variables["ids"];
    if(!Array.isArray(ids) || ids.length === 0) {
        return <div>No Change</div>;
    }

    return <ul>
        {ids.map(id => <li key={keyify(id)}>{ensureNotObject(id)}</li>)}
    </ul>;
}